module.exports = __webpack_public_path__ + "static/media/btn-loader.70392d3b.gif";